import {HTTP_METHODS} from '@/utils/constants/httpMethods'

export const PROMOTION_LIST_CONFIG = {
  PROMOTIONS_LIST: {
    endPoint: 'promotion/filter',
    method: HTTP_METHODS.POST,
    // mockData: promotionListData,
    baseUrlKey: 'inventoryApiUrl',
    headers: {
      countryCode: 'MX',
    },
  },
  PROMOTION_DETAIL: {
    endPoint: 'promotion/{promotionId}',
    method: HTTP_METHODS.GET,
    baseUrlKey: 'inventoryApiUrl',
    headers: {
      countryCode: 'MX',
    },
  },
  DOWNLOAD_PROMOTIONS_LIST: {
    endPoint: 'promotion/download',
    method: HTTP_METHODS.POST,
    baseUrlKey: 'inventoryApiUrl',
    headers: {
      countryCode: 'MX',
    },
  },
  DOWNLOAD_PROMOTIONS_TEMPLATE: {
    endPoint: 'promotion/template/download',
    method: HTTP_METHODS.GET,
    baseUrlKey: 'inventoryApiUrl',

    headers: {
      countryCode: 'MX',
    },
  },
  DOWNLOAD_UPLOADED_PROMOTION_FILE: {
    endPoint: 'promotion/download/{fileUploadId}',
    method: HTTP_METHODS.GET,
    baseUrlKey: 'inventoryApiUrl',

    headers: {
      countryCode: 'MX',
    },
  },

  DOWNLOAD_PROMOTION_FILE_UPLOAD_ERRORS: {
    endPoint: 'promotion/file/{fileUploadId}/process/errors',
    method: HTTP_METHODS.GET,
    baseUrlKey: 'inventoryApiUrl',

    headers: {
      countryCode: 'MX',
      Accept: 'text/csv',
    },
  },

  PROMOTION_FILE_UPLOAD_ERRORS: {
    endPoint: 'promotion/file/{fileUploadId}/process/errors',
    method: HTTP_METHODS.GET,
    baseUrlKey: 'inventoryApiUrl',

    headers: {
      countryCode: 'MX',
      Accept: 'application/json',
    },
  },

  PROMOTION_UPLOAD_HISTORY: {
    endPoint: 'promotion/file/upload',
    method: HTTP_METHODS.GET,
    baseUrlKey: 'inventoryApiUrl',

    headers: {
      countryCode: 'MX',
    },
  },

}
